import { colors } from '@ardoq/design-tokens';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';
import styled from 'styled-components';

type KeyHintProps = {
  text?: string;
  icon?: IconName;
  'aria-label'?: string;
};

const StyledKbd = styled.kbd`
  font-family: -apple-system, system-ui, sans-serif;
  display: inline-flex;
  align-items: center;
`;

export const KeyHint = ({
  text,
  icon,
  'aria-label': ariaLabel,
}: KeyHintProps) => (
  <FlexBox
    align="center"
    justify="center"
    backgroundColor="surfaceStatusNeutral"
    paddingX="xxsmall"
    minWidth="20px"
    minHeight="20px"
    borderRadius="r4"
  >
    <StyledKbd aria-label={ariaLabel}>
      {icon !== undefined ? (
        <Icon
          iconName={icon}
          iconSize={IconSize.MEDIUM}
          color={colors.textSubtle}
        />
      ) : (
        <Text variant="text2" color="textSubtle">
          {text}
        </Text>
      )}
    </StyledKbd>
  </FlexBox>
);
